import React from 'react';
import styled from "styled-components";
import {Img} from "./Img";
import {Container} from "react-bootstrap";
import Title from "./Title";
import reactHtmlParser from "react-html-parser";
import VisibilitySensor from "react-visibility-sensor";
import {bold, white} from "../styles/globalStyleVars";
import ReactHtmlParser from "react-html-parser";

const InnerBanner = ({mimg,img, text, title}) => {
    return (
        <StyledInnerBanner className='InnerBanner parallax'>
            {
                window?.innerWidth>767 ?
                    <Img parallax banner={true} src={img}/> :
                    <Img banner={true} src={mimg ? mimg : img}/>
            }
            <Container>
                <p>{ReactHtmlParser(text)}</p>
                <h1 className={`anim-active fade-up`}>{reactHtmlParser(title)}</h1>
            </Container>
        </StyledInnerBanner>
    );
};

const StyledInnerBanner = styled.section`
  padding-top: calc(620 / 1366 * 100%);
  position: relative;
  background-color: #DDD;

  &:after {
    content: '';
    position: absolute;
    //background-color: rgba(0, 0, 0, 0.25);
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
  }

  .container {
    position: absolute;
    //height: 100%;
    //top: 0;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 80px;
    z-index: 2;
  }

  p {
    line-height: 20px;
    padding-bottom: 20px;
    margin-bottom: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  h1 {
    //position: absolute;
    left: 15px;
    //bottom: 94px;
    color: #ffffff;
    //text-transform: capitalize;
    z-index: 2;
    font-size: 60px;
    line-height: 64px;
    font-family: ${bold};


    span {
      font-weight: 600;
      color: ${white};
    }
  }

  @media (min-width: 767px) {
    .title {
      width: 50%;
    }
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 40px;
      line-height: 44px;
    }

    //padding-top: 0;
    padding-top: calc(560 / 414 * 100%);
    .container {
      bottom: 69px;
    }

    .title {
      margin-bottom: 40px !important;
    }
  }
`;

export default InnerBanner;
